import { snakeCase, text, timestamp, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitApplicationsTable } from './benefit-applications.table'

export const vouchersTable = snakeCase.table('vouchers', {
    id: id('vch'),
    benefitApplicationId: text()
        .notNull()
        .unique()
        .references(() => benefitApplicationsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
    code: varchar({ length: 100 }).notNull().unique(),
    issuedAt: timestamp({ withTimezone: true }).defaultNow(),
    redeemedAt: timestamp({ withTimezone: true }),
    expiresAt: timestamp({ withTimezone: true }),
    ...timestamps,
})
